"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountRepository = void 0;
const AccountRepositoryImpl_1 = require("./AccountRepositoryImpl");
const Fetcher_1 = require("../../utilities/Fetcher");
const accountRepository = new AccountRepositoryImpl_1.AccountRepositoryImpl(Fetcher_1.fetcherAmplify, Fetcher_1.fetcherAxios);
exports.accountRepository = accountRepository;
//# sourceMappingURL=index.js.map